import React,{ useState, useEffect }  from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Avatar, Chip, Card, IconButton, Snackbar, Slide,Button,Divider  } from "@mui/material";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront"; // 아이콘 예시
import PlaceIcon from "@mui/icons-material/Place"; // 아이콘 예시
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FavoriteIcon from "@mui/icons-material/Favorite"; // ❤️ 좋아요 아이콘
import { supabase } from "../supabaseClient";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EditIcon from '@mui/icons-material/Edit';
import { getPermissionNotification } from "utils/ui";

const FindListItem = (props) => {
  const { id, title, address, use, link, is_parking, price, is_reservation, userId, isAdmin } = props;

  // 좋아요 상태 관리
  const [liked, setLiked] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // ✅ 현재 사용자가 이 장소를 좋아요했는지 체크
  useEffect(() => {
    if (!userId) return;
    const fetchWishlist = async () => {
      const { data, error } = await supabase
        .from("wishlist")
        .select("id")
        .eq("user_id", userId)
        .eq("place_id", Number(id));

      if (error) {
        console.error("위시리스트 불러오기 실패:", error.message);
      } else if (data.length > 0) {
        setLiked(true);
      }
    };

    fetchWishlist();
  }, [userId, id]);

  //좋아요 토글 함수 (Supabase에 추가/삭제)
  const toggleLike = async (event) => {
    event.stopPropagation(); // 부모 `Button`의 클릭 이벤트 방지
    if (!userId) {
      setSnackbarMessage("로그인이 필요합니다.");
      setOpenSnackbar(true);
      return;
    }

    if (liked) {
      // 💔 위시리스트에서 삭제
      const { error } = await supabase
        .from("wishlist")
        .delete()
        .eq("user_id", userId)
        .eq("place_id", id);

      if (error) {
        console.error("위시리스트 삭제 실패:", error.message);
      } else {
        setLiked(false);
        setSnackbarMessage("위시리스트에서 삭제되었습니다.");
        setOpenSnackbar(true);
      }
    } else {
      // ❤️ 위시리스트에 추가
      const { error } = await supabase
        .from("wishlist")
        .insert([{ user_id: userId, place_id: id }]);

      if (error) {
        console.error("위시리스트 추가 실패:", error.message);
      } else {
        setLiked(true);
        setSnackbarMessage("위시리스트에 추가되었습니다.");
        setOpenSnackbar(true);
      }
    }
  };
  const navigate = useNavigate();
  const handleEditClick = () => {
    navigate(`/place/edit/${id}`);
  };

  const handleNotification = () =>{
    getPermissionNotification();
  }

  const handleNaverMapClick = (address) => {
    const encoded = encodeURIComponent(address);
    const appUrl = `nmap://search?query=${encoded}`;
    const webUrl = `https://map.naver.com/v5/search/${encoded}`;
  
    // 앱으로 먼저 시도, 일정 시간 후 실패 시 웹으로 fallback
    window.location.href = appUrl;
  
    setTimeout(() => {
      // 앱으로 이동하지 못했으면 웹으로 fallback
      window.open(webUrl, "_blank");
    }, 1000); // 앱 전환까지 기다리는 시간
  };

  return (
    <>
    <Card
      variant="outlined"
      sx={{
        width:"100%",
        display: "flex",
        flexDirection:"column",
        boxSizing:"border-box",
        borderRadius: 2,
        backgroundColor: "#F9FAFB",
        mb: 2,
        p:2,
      }}
    >
      <Box sx={{display:'flex',gap:1,alignItems:"center",justifyContent:"center"}}>
        {/* 좌측 아이콘 */}
        <Avatar
          sx={{
            backgroundColor: "white",
            border: "1px solid #E0E0E0",
            width: 24,
            height: 24,
            p:1,
            flexGrow:0,flexShrink:0
          }}
        >
          <VideoCameraFrontIcon sx={{ color: "#00BFA5", fontSize: 24 }} />
        </Avatar>

        {/* 장소 정보 */}
        <Box sx={{textAlign:'left',flexGrow:1,flexShrink:1,pt:1,pb:1,width:'50%'}}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{lineHeight:1.2}}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{pt:0.5,lineHeight:1.1}}>
            {address}
          </Typography>
        </Box>

        {/* ❤️ 좋아요 버튼 */}
        <Box sx={{flexGrow:0,flexShrink:0,p:1}}>
          {!isAdmin ? (
            <IconButton
              onClick={toggleLike}
              sx={{ transition: "0.3s", width: 20, height: 20, p: 1 }}
            >
              <FavoriteIcon sx={{ color: liked ? "error.main" : "grey.400" }} />
            </IconButton>
          ) : (
            <IconButton
              onClick={handleEditClick}
              sx={{ transition: "0.3s", width: 20, height: 20, p: 1 }}
            >
              <EditIcon />
            </IconButton>
          )}
        </Box>
      </Box>
      {!isAdmin && (
        <>
        <Divider sx={{mb:0}} />
        <Box sx={{display:'flex',gap:0.5, p:1}}>
            {use ? <Chip label="영업중" size="small" color="primary" /> : <Chip label="미운영" size="small" color="error" />}
            {is_reservation ? <Chip label="예약필수" size="small" color="primary" /> : <Chip label="상시입장" size="small" />}
            {is_parking ? <Chip label="주차가능" size="small" color="success" /> : <Chip label="주차불가" size="small" />}
            {price == null ? <Chip label="무료" size="small" color="secondary" /> : <Chip label="유료" size="small" />}
        </Box>
        <Divider sx={{mb:1}} />
        <Box sx={{display:"flex",gap:0.5}}>
          <Button variant="outlined" onClick={()=>handleNaverMapClick(address)} startIcon={<PlaceIcon />} sx={{flex:1,backgroundColor:"#fff"}}>지도보기</Button>
          <Button variant="outlined" onClick={() => { if (link) window.location.href = link; }} startIcon={<CalendarMonthIcon />} sx={{flex:1,backgroundColor:"#fff"}}>현황보기</Button>
        </Box>
        <Box sx={{display:"flex",gap:0.5,pt:0.5}}>
          <Button variant="outlined" onClick={()=>handleNotification()} color="secondary" startIcon={<NotificationsActiveIcon />} sx={{flex:1,backgroundColor:"#fff"}}>예약 오픈 알람 설정</Button>
        </Box>
      </>
      )}
    </Card>
    {/* ✅ Snackbar 추가: 좋아요 메시지 */}
    <Snackbar
      open={openSnackbar}
      autoHideDuration={2000} // 2초 후 자동 닫힘
      onClose={() => setOpenSnackbar(false)}
      message={snackbarMessage}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // 하단 중앙 위치
      TransitionComponent={Slide} // 슬라이드 애니메이션 추가
    />
    </>
  );
};

export default FindListItem;
